define('app/views/area_selector_view',['app/setup'], function(takhfifan) {

  takhfifan.AreaSelectorView = Backbone.View.extend({

    events: {
      'click li' : 'updateArea'
    },

    initialize: function() {
      var _this = this;

      this.model.on('change:suburb', this.update, this);
      this.update();
      this.render();

      // TODO initialise area, if present
    },

    render: function() {
      var area = this.model.get('area');
      var areas = this.model.get('areas');
      var $selector = this.$('.tkh-area-select').first().empty();
      var $list = this.$('ul').empty();

      $.each(areas, function(key, val) {
        var $option = $('<option></option>');
        var $item = $('<li></li>');
        $option.val(val);

        if (val == '') {
          $option.html('&nbsp;');
          $item.html('&nbsp;');
        } else {
          $option.text(val);
          $item.text(val);
        }

        if (val == area) {
          $option.prop('selected', true);
        }

        $selector.append($option);
        $list.append($item);
      });

      if (areas.length == 0) {
        this.$('span.value').first().empty();
        this.$el.slideUp();
      } else {
        this.$('span.value').first().html(this.$('option:selected').html());
        this.$el.slideDown();
      }
    },

    hideDropdown: function() {
      this.$el.removeClass('dropdown-visible');

      this.$(".item-arrow")
      .removeClass("icon-arrow-drop-up")
      .addClass("icon-arrow-drop-down");
    },

    setArea: function() {
      this.model.set('area', this.$el.val());
    },

    setViewArea: function(area) {
      $option = this.$('option[value="' + area + '"]').first();
      this.$('span.value').first().html($option.html());
      $option.prop('selected', true);
      this.hideDropdown();
    },

    updateArea: function(event) {
      var raw = $(event.target).text();
      var area = raw.match(/^&nbsp;|\s$/) ? '' : raw;
      this.setViewArea(area);

      if (_.isEmpty(area)) {
        this.model.set('area', null);
      } else {
        this.model.set('area', area);
      }
    },

    update: function() {
      this.model.updateAreas();
      this.render();
    }

  });
});

